import { Component, inject } from '@angular/core';
import {RouterOutlet} from '@angular/router';

import {ToastModule} from 'primeng/toast';
import { LayoutService } from './services/layout.service';
import { Brand, FaviconUrl } from './interfaces/application';
import { PrimeNG } from 'primeng/config';
import Pusher from 'pusher-js';
import { AuthService } from './services/auth.service';
(window as any).Pusher = Pusher;

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    ToastModule
],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  private readonly _layoutService: LayoutService = inject(LayoutService);
  private readonly _primengConfig: PrimeNG = inject(PrimeNG);
  private readonly _authService: AuthService = inject(AuthService);

  public ngOnInit() {
    this._hideSplashScreen();
    // this._authService.csrf().subscribe();
    this._layoutService.initUpdateColors(Brand.LOGAME);
    this._layoutService.changeFavicon(FaviconUrl.LOGAME);

    this._primengConfig.setConfig({
      translation: {
        firstDayOfWeek: 0,
        dayNames: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
        dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
        dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
        monthNames: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
                    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
        monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun',
                          'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
        today: 'Hoje',
        clear: 'Limpar'
      },
      overlayAppendTo: 'body',
    })
  }

  private _hideSplashScreen() {
    const splash = document.querySelector('app-root > div');
    if (splash) {
      splash.classList.add('fade-out');
      setTimeout(() => splash.remove(), 500);
    }
  }
}
